/**
 * What to call somebody a document is shared with.
 *
 * A person whose name is the address they were invited at shows the address
 * itself, and so does one with no name at all: a blank reads as a missing
 * person rather than as one who has not arrived.
 */
export const nameOf = (person: {
  firstName: string | null
  lastName: string | null
  email: string
}) =>
  person.firstName === person.email
    ? person.email
    : `${person.firstName ?? ''} ${person.lastName ?? ''}`.trim() ||
      person.email

/** "a", "a and b", "a, b and c". */
export const andList = (parts: readonly string[]) =>
  parts.length < 2
    ? (parts[0] ?? '')
    : `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`
